import { render, staticRenderFns } from "./mobile-promotion.noteV2.vue?vue&type=template&id=2639a52c&scoped=true"
var script = {}
import style0 from "./mobile-promotion.noteV2.vue?vue&type=style&index=0&id=2639a52c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2639a52c",
  null
  
)

export default component.exports